import React from "react";
import charger60 from "./assets/60kWMiniDC.png";
import charger120 from "./assets/120kWMiniDc.png";

const variants = [
  {
    power: "60",
    name: "Mini DC Charger",
    img: charger60,
    alt: "VerdeMobility 60 kW Mini DC Standard EV Charger",
    badge: null,
  },
  {
    power: "120",
    name: "Mini DC Charger",
    img: charger120,
    alt: "VerdeMobility 120 kW Mini DC Pro EV Charger",
    badge: "Most Popular",
  },
];

export default function VariantsSection() {
  return (
    <section className="variants-section" id="variants">
      <div className="container">
        <p className="section-label reveal">Choose Your Model</p>
        <h2 className="section-title reveal">
          Two Variants,<br />One Compact Form
        </h2>
        <p className="section-sub reveal">
          Choose the power output that fits your needs, without changing the
          compact footprint.
        </p>
        <div className="variants-grid">
          {variants.map((v) => (
            <div className="variant-card reveal" key={v.power}>
              {v.badge && <div className="variant-badge">{v.badge}</div>}
              <div className="variant-power">
                {v.power}<span> kW </span>
              </div>
              <div className="variant-name">{v.name}</div>
              <div className="variant-img-wrap">
                <img src={v.img} alt={v.alt} />
              </div>
              <a
                href="https://www.verdemobility.com/get-in-touch#contact-us"
                className="variant-cta primary"
              >
                Request Quote
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
